import {RouteRecordRaw} from "vue-router";
import RcsView from "@/rcs/views/RcsView.vue";
import RcsScheduledView from "@/rcs/views/RcsScheduledView.vue";

const rcsRouter: RouteRecordRaw[] = [
    {
        path: '/rcs',
        name: 'rcs',
        component: RcsView,
        meta: {
            title: 'RCS'
        }
    },
    {
        path: '/rcs/scheduled',
        name: 'rcs.scheduled',
        component: RcsScheduledView,
        meta: {
            title: 'RCS programmés'
        }
    }
];

export default rcsRouter;
